type Props = {
  currentQuestion: any;
};
const RadioField = ({ currentQuestion }: Props) => {
  const { choices, type, responses } = currentQuestion;

  return (
    <>
      <ul style={{ listStyle: "none" }}>
        {choices?.map((choice: any) => {
          const otherResponse = responses?.find(
            (res: any) => res.questionChoiceId === choice.id
          )?.textValue;

          return (
            <li key={choice.id} style={{ marginBottom: "10px" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type={type === "checkbox" ? "checkbox" : "radio"}
                  checked={responses?.find(
                    (res: any) => res.questionChoiceId === choice.id
                  )}
                  readOnly={true}
                  disabled={
                    !responses?.find(
                      (res: any) => res.questionChoiceId === choice.id
                    )
                  }
                />
                <span style={{ marginLeft: "8px", marginRight: "8px" }}>
                  {choice.label}{" "}
                </span>
                {choice?.isOther && otherResponse && (
                  <>
                    -
                    <span style={{ marginLeft: "8px", fontWeight: "bold" }}>
                      {" "}
                      {otherResponse || ""}
                    </span>
                  </>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};
export default RadioField;
